<template>
  <v-layout
    row
    wrap
    justify-center
    align-center
    class="loading-ball text-xs-center mt-3"
  >
    <v-flex xs12>
      <line-scale-loader
        color="#C2C2C2"
        size="60px"
      ></line-scale-loader>
    </v-flex>
  </v-layout>
</template>

<script>
export default {};
</script>
